const _excluded = ["className", "style"],
  _excluded2 = ["buttons"],
  _excluded3 = ["focus", "aria", "touchAction"],
  _excluded4 = ["toolbar", "open", "close", "controller", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { LightboxRoot, cssVar, clsx, cssClass, createModule } from '../../index.js';
import * as React from 'react';
import { ACTION_CLOSE, MODULE_NO_SCROLL, MODULE_PORTAL, PLUGIN_INLINE } from '../../types.js';
function InlineContainer(_ref) {
  let _ref$inline = _ref.inline,
    _ref$inline2 = _ref$inline === void 0 ? {} : _ref$inline,
    className = _ref$inline2.className,
    style = _ref$inline2.style,
    rest = _objectWithoutProperties(_ref$inline2, _excluded),
    styles = _ref.styles,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(LightboxRoot, _objectSpread({
    className: clsx(cssClass("relative"), className),
    style: _objectSpread(_objectSpread({
      [cssVar("controller_overscroll_behavior")]: "contain auto"
    }, styles.root), style)
  }, rest), children);
}
function Inline(_ref2) {
  let augment = _ref2.augment,
    replace = _ref2.replace,
    remove = _ref2.remove;
  augment(_ref3 => {
    let _ref3$toolbar = _ref3.toolbar,
      buttons = _ref3$toolbar.buttons,
      restToolbar = _objectWithoutProperties(_ref3$toolbar, _excluded2),
      open = _ref3.open,
      close = _ref3.close,
      _ref3$controller = _ref3.controller,
      focus = _ref3$controller.focus,
      aria = _ref3$controller.aria,
      touchAction = _ref3$controller.touchAction,
      restController = _objectWithoutProperties(_ref3$controller, _excluded3),
      className = _ref3.className,
      restProps = _objectWithoutProperties(_ref3, _excluded4);
    return _objectSpread({
      open: true,
      close: () => {},
      toolbar: _objectSpread({
        buttons: buttons.filter(button => button !== ACTION_CLOSE)
      }, restToolbar),
      inline: {
        style: {
          width: "100%",
          height: "100%"
        },
        className
      },
      controller: _objectSpread({
        focus: false,
        aria: true,
        touchAction: "pan-y"
      }, restController),
      className
    }, restProps);
  });
  remove(MODULE_NO_SCROLL);
  replace(MODULE_PORTAL, createModule(PLUGIN_INLINE, InlineContainer));
}
export { Inline as default };